// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".need-help-container{background-color:var(--background-color);font-size:1.2em}.need-help-container .need-help-grid{max-width:600px;height:60px;margin:auto;padding:32px 24px;display:flex;justify-content:space-between}.need-help-container .need-help-grid .need-help-cell{display:flex;flex-direction:column;justify-content:center;align-items:center}.need-help-container .need-help-grid .need-help-cell span{padding:2px 0}.need-help-container .need-help-grid .need-help-cell span.af{font-size:1.5em}.need-help-container .need-help-grid .need-help-cell .need-help-caption-call-callword{display:none}@media (max-width: 767px){.need-help-container .need-help-grid .need-help-cell .need-help-caption-call-number{display:none}.need-help-container .need-help-grid .need-help-cell .need-help-caption-call-callword{display:block}}\n", ""]);
// Exports
exports.locals = {
	"extraSmallBreakpoint": "320px",
	"smallBreakpoint": "425px",
	"mobileBreakpoint": "768px",
	"tabletBreakpoint": "970px",
	"desktopBreakpoint": "1200px",
	"largeBreakpoint": "1400px",
	"extraLargeBreakpoint": "1600px"
};
module.exports = exports;
